import PropTypes from 'prop-types';
import { memo } from 'react';

import { Anjouan } from '@sportsbook/common/components/footer/licenses/anjouan/anjouan';
import { Antillephone } from '@sportsbook/common/components/footer/licenses/antillephone/antillephone';
import { Curacao } from '@sportsbook/common/components/footer/licenses/curacao/curacao';
import { Custom } from '@sportsbook/common/components/footer/licenses/custom/custom';
import { useConfig } from '@sportsbook/common/context/config-provider';

const LICENSE_COMPONENTS = {
  anjouan: Anjouan,
  antillephone: Antillephone,
  curacao: Curacao,
  custom: Custom,
};

function FooterLicenseUI({ className }) {
  const config = useConfig();
  const LicenseComponent = LICENSE_COMPONENTS[config.site?.license?.type];

  if (!LicenseComponent) return null;

  return <LicenseComponent className={className} />;
}

FooterLicenseUI.propTypes = {
  className: PropTypes.string,
};

FooterLicenseUI.defaultProps = {
  className: undefined,
};

export const FooterLicense = memo(FooterLicenseUI);
